<template>
  <div class="card card-pad-lg h-100">
    <div class="section-title text-center">Ingresos</div>
    <div style="margin-top:30px;">
      <highcharts :options="options" />
    </div>
    <div class="payment-breakdown mt-4 text-center">
      <div class="method">
        <span class="label">Efectivo:</span>
        <span class="value">{{ formatCurrency(payments.cash) }}</span>
      </div>
      <div class="method">
        <span class="label">Tarjeta:</span>
        <span class="value">{{ formatCurrency(payments.card) }}</span>
      </div>
      <div class="method">
        <span class="label">Bizum:</span>
        <span class="value">{{ formatCurrency(payments.bizum) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AreaCard',
    props: {
      options: { type: Object, required: true },
      payments: { type: Object, default: () => ({ cash: 0, card: 0, bizum: 0 }) }
    },
    methods: {
      formatCurrency(value) {
        return value.toLocaleString("es-ES", {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 2
        });
      }
    }
  }
</script>

<style scoped>
  .payment-breakdown {
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
    margin-top: 15px;
    padding-top: 10px;
    border-top: 1px solid #eee;
    color: #374151;
  }

  .payment-breakdown .method {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
    font-size: 14px;
    background: #f9fafb;
    padding: 6px 12px;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  }

  .payment-breakdown .value {
    font-weight: 700;
    color: #111827;
  }
</style>
